import isSuccessfulLink from './isSuccessfulLink';

export const getParameters = (parameters: string): URLSearchParams => {
  const params = new URLSearchParams(parameters);
  const newParams = new URLSearchParams();

  if (isSuccessfulLink(params)) {
    newParams.append('state', params.get('state') || 'UNDEFINED');
    newParams.append('code', params.get('code') as string);
  } else {
    const unexpectedError = 'Unexpected error';
    const missingErrorDescription = `Missing Error Description: ${window.location.search}`;

    newParams.append('errorDescription', params.get('error-description') ?? missingErrorDescription);
    newParams.append('error', params.get('error') ?? unexpectedError);
    newParams.append('state', params.get('state') ?? 'UNDEFINED');
  }
  return newParams;
};

export const getParametersFromCurrentUrl = (): URLSearchParams => {
  return getParameters(window.location.search);
};
